import { useState } from "react";
import Tabs from "@/components/Usados/Tabs";
import ListarUsuarios from "./usuariosTab/listar";
import CrearUsuario from "./usuariosTab/crear";

export default function UsuariosTab() {
  const [activeTab, setActiveTab] = useState("Listar");
  const [usuarioParaEditar, setUsuarioParaEditar] = useState<any>(null);

  const handleEditar = (usuario: any) => {
    setUsuarioParaEditar(usuario);
    setActiveTab("crear");
  };

  const handleFinalizado = () => {
    setUsuarioParaEditar(null);
    setActiveTab("Listar");
  };

  const tabs = [
    {
      value: "Listar",
      label: "Lista de usuarios",
      content: <ListarUsuarios onEdit={handleEditar} />,
    },
    {
      value: "crear",
      label: usuarioParaEditar ? "Editar asignacion" : "Asignar usuario",
      content: (
        <CrearUsuario
          usuario={usuarioParaEditar} empleadoProyecto={usuarioParaEditar}
          onSuccess={handleFinalizado}
          onCancel={() => {
            setUsuarioParaEditar(null);
            setActiveTab("Listar");
          }}
        />
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        activeTextClass="text-green-800"
        activeBorderClass="border-green-800"
        activeGlowClass="bg-green-800/40"
      />
    </div>
  );
}
